import { jwtDecode } from 'jwt-decode';

/** Role string used across the admin UI (API ``UserRole.value``). */
export type AdminUiRole = 'superadmin' | 'admin' | 'editor' | 'user';

export interface JWTPayload {
  sub: string; // user_id
  exp: number; // expiration timestamp
  iat?: number; // issued at
  /** Backend may send enum name (``SUPERADMIN``) or legacy value (``superadmin``). */
  role?: string;
  username?: string;
  email?: string;
}

/** Map JWT ``role`` from backend (enum **name** or **value**) to UI canonical value. */
export function normalizeAdminJwtRole(
  raw: string | undefined
): AdminUiRole | null {
  if (!raw) return null;
  const map: Record<string, AdminUiRole> = {
    superadmin: 'superadmin',
    SUPERADMIN: 'superadmin',
    admin: 'admin',
    ADMIN: 'admin',
    editor: 'editor',
    EDITOR: 'editor',
    user: 'user',
    USER: 'user',
  };
  return map[raw] ?? null;
}

export const decodeToken = (token: string): JWTPayload | null => {
  try {
    return jwtDecode<JWTPayload>(token);
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
};

export const getTokenRole = (token: string): AdminUiRole | null => {
  const decoded = decodeToken(token);
  return normalizeAdminJwtRole(decoded?.role);
};
